// Horizon cards already carry option media IDs and matching slides. Warm only
// an engaged swatch; leave native URL, availability and gallery selection intact.
const { canSpeculate, prepareImage, displayImage } = await import(
  document.querySelector('script[data-tcs-media-cache]')?.dataset.tcsMediaCache ||
    './tcs-variant-image-cache.js'
);
function prepare(event) {
  if (!canSpeculate()) return;
  const card = event.target.closest?.('product-card');
  const control = event.target.closest?.('label')?.querySelector('input') || event.target;
  const id = control?.dataset?.optionMediaId;
  if (!card || !id) return;
  const slide = card.querySelector(`slideshow-slide[slide-id="${CSS.escape(id)}"]`);
  const image = slide?.querySelector('img');
  if (!image) return;
  prepareImage(
    {
      src: image.src,
      width: Number(image.getAttribute('width')) || image.naturalWidth,
      height: Number(image.getAttribute('height')) || image.naturalHeight,
      alt: image.alt,
    },
    card.getBoundingClientRect().width,
    { isActive: () => card.isConnected },
  ).catch(() => {});
}
for (const type of ['pointerover', 'focusin', 'pointerdown'])
  document.addEventListener(type, prepare);

// Mobile has no hover. Commit the already identified slide as soon as its image
// is decoded, without waiting for the native card's section-response listener.
const selections = new WeakMap();
document.addEventListener(
  'change',
  async (event) => {
    const control = event.target;
    const card = control.closest?.('product-card');
    const id = control.dataset?.optionMediaId;
    if (!card || !id) return;
    selections.get(card)?.abort();
    const request = new AbortController();
    selections.set(card, request);
    const slide = card.querySelector(`slideshow-slide[slide-id="${CSS.escape(id)}"]`);
    const image = slide?.querySelector('img');
    if (!image) return;
    try {
      const prepared = await displayImage(
        {
          src: image.src,
          width: Number(image.getAttribute('width')) || image.naturalWidth,
          height: Number(image.getAttribute('height')) || image.naturalHeight,
          alt: image.alt,
        },
        card.getBoundingClientRect().width,
        { signal: request.signal, isActive: () => card.isConnected, sizes: image.sizes },
      );
      if (!card.isConnected || !control.isConnected || request.signal.aborted || !control.checked)
        return;
      prepared.className = image.className;
      if (image.hasAttribute('ref')) prepared.setAttribute('ref', image.getAttribute('ref'));
      image.replaceWith(prepared);
      card.querySelector('slideshow-component')?.select?.({ id }, undefined, { animate: false });
    } catch {
      /* Native selection and complete existing image remain the fallback. */
    }
  },
  { capture: true },
);
